import {Location, History} from 'history';

const navStack: Location<History.PoorMansUnknown>[] = [];
let currentNavStackIndex = 0;

export function initNav(history: History) {
  navStack.length = 0;
  navStack.push(history.location);
  currentNavStackIndex = 0;
  history.listen((location, action) => {
    if (action === "PUSH") {
      if(currentNavStackIndex < navStack.length - 1) {
        navStack.splice(currentNavStackIndex + 1, navStack.length - currentNavStackIndex - 1);
      }
      navStack.push(location);
      currentNavStackIndex = navStack.length - 1;
    } else if(action === "REPLACE") {
      navStack[currentNavStackIndex] = location;
    } else if(action === "POP") {
      // POP can be either back or forward navigation
      if(currentNavStackIndex < navStack.length - 1 && navStack[currentNavStackIndex + 1].pathname === location?.pathname) {
        // forward
        currentNavStackIndex++;
      } else {
        // back
        currentNavStackIndex--;
      }
    }
  });
}

export function getPrevPagePath(): string|null {
  return currentNavStackIndex > 0 ? navStack[currentNavStackIndex - 1].pathname : null;
}